import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/TermsAndConditions.jsx");
